import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromActions from './env.actions';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { EnvironmentService } from '../service';

@Injectable()
export class EnvEffects {
  loadEnvironment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadEnvironment),
      switchMap((action) =>
        this.environmentService.loadEnvironment(action.environmentConfiguration).pipe(
          map((environment) => fromActions.loadEnvironmentSuccess({ environment })),
          catchError(() => of(fromActions.loadEnvironmentFailure()))
        )
      )
    )
  );

  loadMockEnvironment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadMockEnvironment),
      switchMap((_action) =>
        this.environmentService.loadAndApplyMockEnvironment().pipe(
          map((environment) => fromActions.loadEnvironmentSuccess({ environment })),
          catchError(() => of(fromActions.loadEnvironmentFailure()))
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly environmentService: EnvironmentService
  ) {}
}
